import { SelectIF } from '@/types/common';
import { FITS_PROPERTIES, LOWER_FITS_PROPERTIES } from '@/constants/fits';
import { WardrobeCategoryT } from '@/constants/wardrobeCategoryTabs';

const FIT_PROPERTIES_BY_WARDROBE_CATEGORY_TYPE: Partial<
    Record<WardrobeCategoryT, SelectIF[]>
> = {
    upper: FITS_PROPERTIES,
    lower: LOWER_FITS_PROPERTIES,
    outerwear: FITS_PROPERTIES,
    fullOutfit: FITS_PROPERTIES,
};

export const getFitPropertiesByWardrobeCategoryType = (
    categoryType: WardrobeCategoryT,
): SelectIF[] | null =>
    FIT_PROPERTIES_BY_WARDROBE_CATEGORY_TYPE[categoryType] ?? null;
